import { useEffect, useState } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'
import { RefreshCw, X } from 'lucide-react'

export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      if (!r) return
      // Polling cada 15min (era 1h — demasiado lento en una app que cambia varias
      // veces al día y se instala como PWA).
      const id = setInterval(() => { r.update().catch(() => {}) }, 15 * 60 * 1000)

      // Forzar check cuando el user vuelve a la pestaña/PWA. Sin esto, una PWA
      // instalada que se abre desde el ícono y se queda abierta tarda hasta el
      // próximo polling en detectar la versión nueva.
      const onVisible = () => {
        if (document.visibilityState === 'visible') {
          r.update().catch(() => {})
        }
      }
      if (typeof document !== 'undefined') {
        document.addEventListener('visibilitychange', onVisible)
      }

      if (typeof window !== 'undefined') {
        window.addEventListener('beforeunload', () => {
          clearInterval(id)
          document.removeEventListener('visibilitychange', onVisible)
        }, { once: true })
      }
    },
  })

  const [visible, setVisible] = useState(false)
  useEffect(() => { if (needRefresh) setVisible(true) }, [needRefresh])

  if (!visible) return null

  return (
    <div className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:w-[360px] z-[60]">
      <div
        className="rounded-2xl p-4 pr-3 flex items-start gap-3"
        style={{
          background: 'linear-gradient(135deg, rgba(34,211,238,0.08), rgba(139,92,246,0.08))',
          border: '1px solid rgba(34,211,238,0.3)',
          backdropFilter: 'blur(18px)',
          WebkitBackdropFilter: 'blur(18px)',
          boxShadow: '0 20px 60px -10px rgba(0,0,0,0.7)',
        }}
      >
        <div className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0 cyan-pulse" style={{ background: 'linear-gradient(135deg, #22D3EE, #8B5CF6)' }}>
          <RefreshCw size={16} className="text-white" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-display text-sm text-white" style={{ fontVariationSettings: '"wght" 600, "opsz" 96' }}>
            Nueva versión disponible
          </p>
          <p className="text-muted text-xs mt-0.5 leading-relaxed">
            Actualiza para ver las últimas mejoras.
          </p>
          <div className="flex items-center gap-2 mt-3">
            <button
              onClick={() => { setVisible(false); updateServiceWorker(true) }}
              className="btn-ai !py-2 !px-3.5 !text-xs"
            >
              <RefreshCw size={12} /> Actualizar
            </button>
            <button
              onClick={() => { setVisible(false); setNeedRefresh(false) }}
              className="text-xs text-muted hover:text-white transition-colors px-2 py-2"
            >
              Después
            </button>
          </div>
        </div>
        <button
          onClick={() => { setVisible(false); setNeedRefresh(false) }}
          className="text-dim hover:text-white transition-colors p-1 -mr-1 -mt-1"
          aria-label="Cerrar"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  )
}
